import React from 'react'
import { Loader } from '@sendoutcards/quantum-design-ui'
import { useSelector } from 'src/hooks'
import styles from './giftTile.module.scss'

export const GiftTileLoader: React.FC = () => {
  const isMobile = useSelector(state => state.window.width <= 1023)

  const imageWidth = isMobile ? 245 : 305
  const imageHeight = isMobile ? 237 : 320

  return (
    <div className={styles.itemContainer}>
      {/* Gift image skeleton */}
      <div className={styles.giftImageContainer}>
        <Loader width={imageWidth} height={imageHeight}>
          <rect width={imageWidth} height={imageHeight} />
        </Loader>
      </div>

      {/* Item details skeleton */}
      <div className={styles.itemDetails}>
        {/* Title skeleton */}
        <Loader width={imageWidth - 32} height={20}>
          <rect x={0} y={0} width={imageWidth - 32} height={20} rx={4} ry={4} />
        </Loader>

        {/* Price label skeleton */}
        <div style={{ marginTop: '12px' }}>
          <Loader width={50} height={12}>
            <rect x={0} y={0} width={50} height={12} rx={2} ry={2} />
          </Loader>
        </div>

        {/* Price value skeleton */}
        <div style={{ marginTop: '8px' }}>
          <Loader width={80} height={16}>
            <rect x={0} y={0} width={80} height={16} rx={4} ry={4} />
          </Loader>
        </div>
      </div>
    </div>
  )
}
